module.exports = __webpack_public_path__ + "img/BackpackLaptopTotes.b8f774e0.png";